//import axios from "axios";
import React, { useEffect, useState } from "react";
import ImprimirProgramacion from "../components/cirugia/imprimirProgramacion/ImprimirProgramacion";
import ModalProgramacionDeUnaCirugiaN from "../components/cirugia/programacionDeUnaCirugia/ModalProgramacionDeUnaCirugiaN";
import Loading from "../components/Loading";
import TablaProgramacionCirugia from "../components/TablaProgramacionCirugia";
import { fechaActual } from "../hooks/UseDate";
import { getObtenerTodasOpcionesCirugia, postBuscarPacientesEnUnaProgramacionModificar, postCirugiaQuirofano } from "../services/PaginaRuta";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { UserTokenURL } from "../services/ApiHIS";

const BucarPacienteProgramacionCirugia = () => {
  const [userDate, setUserDate] = useState([]);
  const [passActualizarTablaPacientes, setpassActualizarTablaPacientes] =
    useState({});
  const [modalOnProgramacionDeCirugia, setmodalOnProgramacionDeCirugia] =
    useState(false);
  const [modalOnImprimirProgramacion, setmodalOnImprimirProgramacion] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [dataQuirofanos, setdataQuirofanos]=useState([])
  const [dataOpcionCirugia, setdataOpcionCirugia]=useState([])

  //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get("token"));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.removeItem("tokenReact");
    localStorage.setItem("tokenReact", tokenCons);
  }, [location]);

  

  const passDataActualizaTablaPacientes = (data) => {
    setpassActualizarTablaPacientes(data);
  };

  

  const searchUserDateApi = (e) => {
    e.preventDefault();
    setLoading(false);
    //console.log(e.target.date.value,'fecha button')
    const body = {
      ProFec: e.target.dateInicial.value,
      ProFecF: e.target.dateFinal.value,
      ProEmpCod: "1",
      ProSedQr: "001",
      MPCedu: e.target.userId.value,
      ProSit: e.target.opcion.value,
      ProCons: e.target.quirofano.value
    };
    postBuscarPacientesEnUnaProgramacionModificar(body).then((res) => {
      //console.log(res.data,'dataultiumaaaaa ulti')
      if (res.data) {
        // setTimeout(() => {
          
        // }, 1000);
        setLoading(true);
        setUserDate(Object.values(res.data));
      }
    })
    .catch(error => {
      
      setLoading(true)
    });
  };

  useEffect(() => {
    setLoading(false);
    const body = {
      ProFec: fechaActual(),
      ProEmpCod: "1",
      ProSedQr: "001",
      ProCirCod: "",
      MPCedu: "",
      ProCons:""
    };
    postBuscarPacientesEnUnaProgramacionModificar(body).then((res) => {
      //console.log(res.data.error,'dataultiumaaaaa')
      if (res.data.error) {
        setUserDate([]);
        setLoading(true);
      } else {
        // setTimeout(() => {
          
        // }, 1000);
        setLoading(true);
        setUserDate(Object.values(res.data));
      }
    })
    .catch(error => {
      
      setLoading(true)
    });
  }, [passActualizarTablaPacientes]);

  //token
  useEffect(() => {
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL();

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios
      .get(url, { headers })
      .then((response) => {
        //console.log(response.data.user_data, 'data user');

        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem("usuarioInfo");
        console.log(localStorage.getItem("usuarioInfo"), "antes data user");
        // Guarda los nuevos datos
        localStorage.setItem(
          "usuarioInfo",
          JSON.stringify(response.data.user_data)
        );

       
      })
      .catch((error) => {
        console.error("Error al autenticar al usuario:", error);
        //seterrorEndpoint(true)
      });
  }, []);

  useEffect(()=>{

    getObtenerTodasOpcionesCirugia().then((res)=>{
      console.log(res.data.data)
      setdataOpcionCirugia(res.data.data)
    })
      
    postCirugiaQuirofano().then((res)=>{
      //console.log(res.data,'data quirofanos')
      setdataQuirofanos(res.data)
    })
  },[])

  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Consolidado Cx
        </div>
        

        <form onSubmit={searchUserDateApi}>
          <div className="flex  md:flex-row md:flex-wrap gap-4 my-3">
    {/* N° documento identidad */}
    <div className="flex-1 mb-3 min-w-[180px] md:min-w-0">
      <label
        htmlFor="userId" // Es buena práctica que el 'for' coincida con el 'id' del input
        className="form-label inline-block mb-2 text-gray-900 font-medium text-base"
      >
        N° documento identidad
      </label>
      {/* Eliminamos el div.flex anidado innecesario */}
      <input
        name="userId"
        type="text"
        className="form-control block w-full px-3 py-0.5 text-sm font-normal text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        id="userId" // ID único para el input
        placeholder=""
      />
    </div>

    {/* Opción */}
    <div className="flex-1 mb-3 min-w-[180px] md:min-w-0">
      <label htmlFor="opcion" className="form-label inline-block mb-2 text-gray-900 font-medium">
        Opción
      </label>
      <select
        id="opcion" // ID para el select
        className="form-select block w-full px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        aria-label="Seleccionar Opción" // aria-label más descriptivo
        name="opcion"
      >
        <option value="">Sin seleccionar</option>
        {dataOpcionCirugia.map((item) => (
          <option value={item.PrcMulOpc} key={item.PrcMulOpc}>
            {item.PrcMulDsc}
          </option>
        ))}
      </select>
    </div>

    {/* Quirófano */}
    <div className="flex-1 mb-3 min-w-[180px] md:min-w-0">
      <label htmlFor="quirofano" className="form-label inline-block mb-2 text-gray-900 font-medium">
        Quirófano
      </label>
      <select
        id="quirofano" // ID para el select
        className="form-select block w-full px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        aria-label="Seleccionar Quirófano" // aria-label más descriptivo
        name="quirofano"
      >
        <option value="">Sin seleccionar</option>
        {dataQuirofanos.map((item, index) => (
          <option value={item.ConsCod} key={index} className="text-sm">
            {item.ConsDet}
          </option>
        ))}
      </select>
    </div>

    {/* Fecha Inicial */}
    <div className="flex-1 mb-3 min-w-[180px] md:min-w-0">
      <label
        htmlFor="dateInicial" // ID para el input de fecha
        className="form-label inline-block mb-2 text-gray-900 font-medium"
      >
        Fecha Inicial
      </label>
      {/* Simplificado: Eliminados divs anidados innecesarios como 'datepicker', 'form-floating' a menos que una librería JS específica los requiera */}
      <input
        defaultValue={fechaActual()} // Asegúrate que fechaActual() esté definida
        type="date"
        name="dateInicial"
        id="dateInicial"
        className="form-control block w-full px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        placeholder="Select a date" // El placeholder puede no ser visible en inputs type="date"
      />
    </div>

    {/* Fecha Final y Botón */}
    <div className="flex-1 mb-3 min-w-[180px] md:min-w-0"> {/* Mantenemos min-w consistente */}
      <label
        htmlFor="dateFinal" // ID para el input de fecha
        className="form-label inline-block mb-2 text-gray-900 font-medium"
      >
        Fecha Final
      </label>
      <div className="flex items-center gap-2"> {/* items-center para alinear verticalmente input y botón si tienen alturas ligeramente diferentes */}
        <input
          defaultValue={fechaActual()} // Asegúrate que fechaActual() esté definida
          type="date"
          name="dateFinal"
          id="dateFinal"
          className="form-control block w-full flex-grow px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
          placeholder="Select a date"
        />
        {/* El botón se coloca al lado del input de fecha final */}
        <button
          type="submit"
          className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out whitespace-nowrap"
        >
          Buscar
        </button>
      </div>
    </div>
</div>
          
          <div className="flex ">
            <div className="mb-3 xl:w-96 flex">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Varios procedimientos qx
              </label>
              <div className="flex">
                <div className="px-2">
                  <input
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#a7f3d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div className="mb-3 xl:w-96 pl-2 flex">
              <div className="ml-2 h-6 w-6 rounded-full bg-blue-300 flex justify-center items-center text-blue-800">
                <svg viewBox="0 0 24 24" className="h-6 w-6">
                  <text
                    x="50%"
                    y="50%"
                    fill="currentColor"
                    font-size="20"
                    text-anchor="middle"
                    alignment-baseline="central"
                  >
                    P
                  </text>
                </svg>
              </div>
              <label className="form-label inline-block mb-2 text-gray-900 font-medium pl-3">
                Programada
              </label>
            </div>
            <div className="mb-3 xl:w-96 pl-2 flex">
              <div className="ml-2 h-6 w-6 rounded-full bg-red-300 flex justify-center items-center text-red-800">
                <svg viewBox="0 0 24 24" className="h-6 w-6">
                  <text
                    x="50%"
                    y="50%"
                    fill="currentColor"
                    font-size="20"
                    text-anchor="middle"
                    alignment-baseline="central"
                  >
                    U
                  </text>
                </svg>
              </div>
              <label className="form-label inline-block mb-2 text-gray-900 font-medium pl-3">
                Urgencias
              </label>
            </div>
            <div className="mb-3 xl:w-96 pl-2 flex">
              <div className="ml-2 h-6 w-6 rounded-full bg-blue-400 flex justify-center items-center text-blue-800">
                <svg viewBox="0 0 24 24" className="h-6 w-6">
                  <text
                    x="50%"
                    y="50%"
                    fill="currentColor"
                    font-size="20"
                    text-anchor="middle"
                    alignment-baseline="central"
                  >
                    A
                  </text>
                </svg>
              </div>
              <label className="form-label inline-block mb-2 text-gray-900 font-medium pl-3">
              Ambulatoria
              </label>
            </div>
          </div>
        </form>

        <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 "
                      >
                        Estado
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 "
                      ></th>
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        N° Cirugía
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Tipo Documento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        N° documento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Nombre
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Fecha
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Procedimiento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Hora Inicio
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Hora Final
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Teléfono
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                      >
                        Quirófano
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 "
                      >
                        Edad
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 "
                      >
                        Contrato
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2 "
                      >
                        Cama
                      </th>
                    </tr>
                  </thead>

                  {loading ? (
                    userDate.map((item, index) => (
                      <TablaProgramacionCirugia
                        user={item}
                        key={index}
                        passDataActualizaTablaPacientes={
                          passDataActualizaTablaPacientes
                        }
                      />
                    ))
                  ) : (
                    <tbody>
                      <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <Loading />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnProgramacionDeCirugia ? (
        <ModalProgramacionDeUnaCirugiaN
          setmodalOnProgramacionDeCirugia={setmodalOnProgramacionDeCirugia}
          passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}
        />
      ) : null}
      {modalOnImprimirProgramacion ? (
        <ImprimirProgramacion
          setmodalOnImprimirProgramacion={setmodalOnImprimirProgramacion}
        />
      ) : null}
      
    </>
  );
};

export default BucarPacienteProgramacionCirugia;
